export default "Fremstil jeres egen maling af naturlige materialer på bedste jægerstenalder manér. Brug fx malingen til et stort fælles hulemaleri.";